/**
 * Header scripts
*/

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

document.addEventListener("DOMContentLoaded", () => {
    const $ = jQuery;

    function setNavbarH() {
        $('.mobile-navigation').css("--navh", $('.site-header').height() + 'px');
    }  

    // Add/remove header "white" class on window scroll event 
    function changeHeaderClassOnScroll() {
        const header = $('.site-header');

        if (window.pageYOffset > 1) {
            header.addClass('bg');
        } else {
            header.removeClass('bg');
        }
    }

    function headerResponsiveFunctions() {
        setNavbarH();

        if($('.site-header-placeholder').length) {
            $('.site-header-placeholder').height($('.site-header').height());
        } else {
            $(window).on('scroll', changeHeaderClassOnScroll);
        }
        
        if (window.matchMedia("screen and (max-width: 1200px)").matches) {
            $('.mega-menu-nav-item').off('mouseenter mouseleave');
        }

        if (window.matchMedia("screen and (min-width: 1201px)").matches) {
            // Add/remove header background on menu item hover  
            $('.mega-menu-nav-item').on('mouseenter mouseleave', function(e) {
    
                if(e.type === 'mouseenter')
                    $('.site-header').addClass('menu-opened');
                else if(e.type === 'mouseleave')
                    $('.site-header').removeClass('menu-opened');
    
            })
        }
    }

    window.addEventListener('resize', headerResponsiveFunctions);
    headerResponsiveFunctions();

    // Animate header hide/show
    const showHeader = gsap.from('.site-header', {
        yPercent: -100,
        paused: true,
        duration: 0.2,
        transform: 'translate: unset'
    }).progress(1);

    ScrollTrigger.create({
        start: `top+=${$('.site-header-placeholder').length ? $('.site-header').height() : 0}`,
        end: 99999,
        onUpdate: (self) => {
            self.direction === -1 ? showHeader.play() : showHeader.reverse()
        }
    });
});